"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Label = _interopRequireDefault(require("./Label"));

var _Slider = _interopRequireDefault(require("../../Slider/Slider"));

var _FlexContainer = _interopRequireDefault(require("../../FlexContainer"));

var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));

var _FieldDescription = _interopRequireDefault(require("../../FieldDescription"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var SliderInput = function SliderInput(_ref) {
  var id = _ref.id,
      _ref$isInputValid = _ref.isInputValid,
      isInputValid = _ref$isInputValid === void 0 ? function () {
    return true;
  } : _ref$isInputValid,
      customLabel = _ref.customLabel,
      max = _ref.max,
      min = _ref.min,
      _onChange = _ref.onChange,
      _ref$postfix = _ref.postfix,
      postfix = _ref$postfix === void 0 ? "%" : _ref$postfix,
      value = _ref.value,
      disabled = _ref.disabled,
      values = _ref.values,
      customMarks = _ref.customMarks,
      options = _ref.options,
      scale = _ref.scale,
      label = _ref.label,
      fieldDescription = _ref.fieldDescription,
      labelTooltip = _ref.labelTooltip;

  var checkValidations = function checkValidations() {
    return true;
  };

  (0, _react.useEffect)(function () {
    isInputValid(checkValidations(value)); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
  return _react.default.createElement(_react.default.Fragment, null, (label || customLabel) && _react.default.createElement(_Label.default, {
    customLabel: label || customLabel,
    tooltip: labelTooltip
  }), fieldDescription && _react.default.createElement(_FieldDescription.default, {
    value: fieldDescription
  }), options !== null && options !== void 0 && options.optional ? _react.default.createElement(_FlexContainer.default, {
    margin: "0 0 0 -15px"
  }, _react.default.createElement(_Checkbox.default, {
    color: "primary",
    onChange: function onChange() {
      return _onChange(id, value ? null : [min, max]);
    },
    checked: !!value,
    style: {
      height: 45,
      marginTop: 5,
      marginRight: 5
    }
  }), _react.default.createElement(_FlexContainer.default, {
    justifyContent: "flex-space-between",
    width: "99%"
  }, _react.default.createElement(_Slider.default, {
    customMarks: customMarks,
    from: value,
    min: min || 0,
    max: max || 0,
    postfix: postfix,
    onChange: function onChange(val) {
      return _onChange(id, val);
    },
    disabled: disabled || !value,
    values: values
  }))) : _react.default.createElement(_Slider.default, {
    customMarks: customMarks,
    from: value,
    min: min || 0,
    max: max || 0,
    postfix: postfix,
    onChange: function onChange(val) {
      return _onChange(id, val);
    },
    disabled: disabled,
    values: values,
    scale: scale
  }));
};

var _default = _react.default.memo(SliderInput);

exports.default = _default;